module.exports = __webpack_public_path__ + "img/horizontal_3_1_6005.3771e5a5.png";